// extracted by mini-css-extract-plugin
export default {"content":"UpdateEmployer_content__2uA-2","skeletonLoadingAnimation":"UpdateEmployer_skeletonLoadingAnimation__p6WUm"};